import React from "react";
import { ColoredSpan } from "../form";

const ModalHelpItem = ({ color, background, symbol, label, firstItem }) => {
  const borderTop = firstItem ? "border-t" : "";
  const symbolBackground = symbol ? background : "";
  return (
    <div className="flex items-center">
      <ColoredSpan
        className={`flex justify-center items-center w-20 h-10 border-x ${borderTop} border-b border-[#616161]`}
        color={color}
        background={symbolBackground}
      >
        {symbol ? symbol : " "}
      </ColoredSpan>
      <div className="w-10 h-[1px] border border-[#2E90FA] absolute left-[112px]"></div>
      <span className="ml-7">{label}</span>
    </div>
  );
};

export default ModalHelpItem;
